import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectDealerSelected } from 'app/pages/Header/selectors';
import { hasDealerContext } from 'utils/hasDealerContext';
import { hasDealerLaunchDate } from 'utils/dealerLaunchDate';

export const useMonitorPage = () => {
  const history = useHistory();
  const selectedDealer = useSelector(selectDealerSelected);
  const hasSelectedDealer = hasDealerContext(selectedDealer);
  const hasLaunchDate = hasDealerLaunchDate(selectedDealer);

  const goToNurturingCandidateAudit = useCallback(() => {
    history.push('/monitor-nurturing-candidate-audit', {
      breadcrumbsList: [
        { label: 'Monitor', link: '/monitor', isActive: false },
        { label: 'Nurturing Candidate Audit', isActive: true },
      ],
    });
  }, [history]);

  const goToNurturingPlanExecution = useCallback(() => {
    if (!hasSelectedDealer || !hasLaunchDate) return;
    history.push('/monitor-nurturing-plan-execution', {
      breadcrumbsList: [
        { label: 'Monitor', link: '/monitor', isActive: false },
        { label: 'Nurturing Plan Execution', isActive: true },
      ],
    });
  }, [hasLaunchDate, hasSelectedDealer, history]);

  return {
    hasSelectedDealer,
    hasLaunchDate,
    goToNurturingCandidateAudit,
    goToNurturingPlanExecution,
  };
};
